import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Home from "./pages/Landing";
// import BlogClassic from "./pages/blog-classic";
// import BlogDetails from "./pages/blog-details";
// import BlogGrid3Columns from "./pages/blog-grid-3columns";
// import BlogGridSidebar from "./pages/blog-grid-sidebar";
// import HomeCreativeAgency from "./pages/home-creative-agency.js";
// import HomeDigitalAgency from "./pages/home-digital-agency.js";
// import HomeMain from "./pages/home-main.js";
// import HomeModernStudio from "./pages/home-modern-studio.js";
import HomePersonal from "./pages/home-personal.js";
import Page404 from "./pages/page-404.js";
// import PageAbout from "./pages/page-about.js";
import PageContact from "./pages/page-contact.js";
import { AppContextProvider } from "./context/AppContext.js";
import { useRef, useState } from "react";
import PDFViewer from "./components/home-personal/PDFViewer.jsx";
import FitnessTracker from "./components/fitness-tracker/index.jsx";
import GreenBasket from "./components/green-basket/index.jsx";
import AgeOfAI from "./components/age-of-ai/index.jsx";
import IntelliPricingModel from "./components/intelligent-pricing-model/index.jsx";
import ChatbotPage from "./pages/chatbot/index.jsx";

function App() {
  const [index, setIndex] = useState(0);
  const sectionRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const handleSectionClick = (index) => {
    window.scrollTo({
      top: sectionRefs[index]?.current?.offsetTop - 72,
      behavior: "smooth",
    });
  };
  return (
    <AppContextProvider
      value={{ sectionRefs, handleSectionClick, index, setIndex }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<ChatbotPage />} />
          <Route path="/home" element={<HomePersonal />} />
          {/* <Route path="/blog-classic" element={<BlogClassic />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/blog-grid-3column" element={<BlogGrid3Columns />} />
        <Route path="/blog-grid-sidebar" element={<BlogGridSidebar />} />
        <Route path="/home-creative-agency" element={<HomeCreativeAgency />} />
        <Route path="/home-digital-agency" element={<HomeDigitalAgency />} />
        <Route path="/home-main" element={<HomeMain />} />
        <Route path="/home-modern-studio" element={<HomeModernStudio />} />
        <Route path="/home-personal" element={<HomePersonal />} /> */}
          <Route path="*" element={<Page404 />} />
          {/* <Route path="/about" element={<PageAbout />} />
          <Route path="/case-studies" element={<PageContact />} /> */}
          <Route path="/contact" element={<PageContact />} />
          <Route path="/case-study/green-basket"
            element={<GreenBasket />}
          />
          <Route
            path="/case-study/fitness-tracker"
            element={<FitnessTracker />}
          />
          <Route
            path="/case-study/age-of-ai"
            element={<AgeOfAI />}
          />
          <Route path="/case-study/intelligent-pricing-model"
            element={<IntelliPricingModel />}
          />

          <Route path="/view-pdf/:pdfName" element={<PDFViewer />} />
          {/* <Route path="/page-FAQ" element={<PageFAQ />} />
        <Route
          path="/page-services-details"
          element={<PageServicesDetails />}
        />
        <Route path="/page-services" element={<PageServices />} />
        <Route path="/page-team" element={<PageTeam />} />
        <Route path="/page-team-details" element={<PageTeamDetails />} />
        <Route path="/portfolio-creative" element={<PortfolioCreative />} />
        <Route
          path="/portfolio-creative-carousel"
          element={<PortfolioCreativeCarousel />}
        />
        <Route path="/portfolio-gallery" element={<PortfolioGallery />} />
        <Route path="/portfolio-grid" element={<PortfolioGrid />} />
        <Route path="/portfolio-masonry" element={<PortfolioMasonry />} />
        <Route path="/project-details" element={<ProjectDetails />} /> */}
        </Routes>
      </Router>
    </AppContextProvider>
  );
}

export default App;
